export default {
    data() {
      return {
        selectedTimeframe: 'All Timeframes',
        timeframeOptions: [
          'All Timeframes',
          'Upcoming (within 3 months)',
          'Future (within 6 months)',
          'Long Term (within 12 months)'
        ]
      };
    },
  
  computed: {
    /**
     * Returns the contracts filtered by the selected timeframe.
     * Expects the component using this mixin to provide a `contracts` prop.
     */
    filteredContracts() {
      if (!this.contracts || this.contracts.length === 0) return [];

      let filtered = [];
      
      if (this.selectedTimeframe === 'Upcoming (within 3 months)') {
        filtered = this.contracts.filter(contract => this.isWithinThreeMonths(contract));
      } else if (this.selectedTimeframe === 'Future (within 6 months)') {
        filtered = this.contracts.filter(contract => this.isWithinThreeToSixMonths(contract));
      } else if (this.selectedTimeframe === 'Long Term (within 12 months)') {
        filtered = this.contracts.filter(contract => this.isWithinSixToTwelveMonths(contract));
      } else {
        filtered = this.contracts;
      }

      // Sort by days_until_expiry (lowest first)
      return filtered.sort((a, b) => {
        const daysA = typeof a.days_until_expiry === 'number' ? a.days_until_expiry : Infinity;
        const daysB = typeof b.days_until_expiry === 'number' ? b.days_until_expiry : Infinity;
        return daysA - daysB;
      });
    }
  },
  
    watch: {
      selectedTimeframe() {
        if (typeof this.currentPage !== 'undefined') {
          this.currentPage = 1;
        }
      },
      contracts() {
        if (typeof this.currentPage !== 'undefined') {
          this.currentPage = 1;
        }
      }
    },
  
    methods: {
      // Upcoming (≤ 3 months)
      isWithinThreeMonths(contract) {
        const urgency = contract.urgency;
        const days = typeof contract.days_until_expiry === 'number'
          ? contract.days_until_expiry
          : null;
  
        if (urgency === 'urgent_3mo' || urgency === '90_days') return true;
        if (days !== null && days <= 90) return true;
  
        return false;
      },
  
      // Future (3–6 months)
      isWithinThreeToSixMonths(contract) {
        const urgency = contract.urgency;
        const days = typeof contract.days_until_expiry === 'number'
          ? contract.days_until_expiry
          : null;
  
        if (urgency === 'medium_6mo' || urgency === '120_days') return true;
        if (days !== null && days > 90 && days <= 180) return true;
  
        return false;
      },
  
      // Long Term (6–12 months)
      isWithinSixToTwelveMonths(contract) {
        const days = typeof contract.days_until_expiry === 'number'
          ? contract.days_until_expiry
          : null;
  
        if (days === null) return false;
        return days > 180 && days <= 365;
      },

      /**
       * Returns the dropdown timeframe option label for a given contract.
       * Used to sync chip clicks with the shared timeframe filter.
       */
      getTimeframeOptionForContract(contract) {
        if (this.isWithinThreeMonths(contract)) {
          return 'Upcoming (within 3 months)';
        }
        if (this.isWithinThreeToSixMonths(contract)) {
          return 'Future (within 6 months)';
        }
        if (this.isWithinSixToTwelveMonths(contract)) {
          return 'Long Term (within 12 months)';
        }
        return 'All Timeframes';
      },

      /**
       * Applies timeframe filter from the clicked contract's urgency bucket.
       */
      setSelectedTimeframeFromContract(contract) {
        const option = this.getTimeframeOptionForContract(contract);
        this.selectedTimeframe = option;
        if (typeof this.applyChipFilterFeedback === 'function' && this.sectionId) {
          this.applyChipFilterFeedback(this.sectionId);
        }
      },
  
      /**
       * Shared card background / border styling based on urgency bucket.
       * Upcoming = orange, Future = blue, Long Term = grey.
       */
      getExpiringContractCardStyle(contract) {
        if (this.isWithinThreeMonths(contract)) {
          return 'cursor: pointer; background-color: #fff9e6; --expiring-contract-card-hover-bg: #fff7de; border-left: 4px solid #f59e0b; border-radius: 0 4px 4px 0;';
        }
        if (this.isWithinThreeToSixMonths(contract)) {
          return 'cursor: pointer; background-color: #f0f9ff; --expiring-contract-card-hover-bg: #e4f2fb; border-left: 4px solid #3b82f6; border-radius: 0 4px 4px 0;';
        }
        // Long Term and anything further out: grey
        return 'cursor: pointer; background-color: #f9fafb; --expiring-contract-card-hover-bg: #f3f4f6; border-left: 4px solid #9e9e9e; border-radius: 0 4px 4px 0;';
      }
    }
  };